import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import useRouterNavigation from './useRouterNavigation';
import StudioRoutes from '@/utils/routes';
import useRedirect from '@/hooks/useRedirect';

const usePageNavigation = () => {
  const router = useRouter();
  const { previousPath = StudioRoutes.home(), previousPageTitle = 'Home' } = useRouterNavigation();
  const { dispatchRedirect } = useRedirect();

  const navigateBack = useCallback(async () => {
    await shopify?.saveBar?.leaveConfirmation?.();

    dispatchRedirect(previousPath);
  }, [previousPath, dispatchRedirect]);

  return { navigateBack, previousPageTitle };
};

export default usePageNavigation;
